import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import useResponsive from '../../hooks/useResponsive';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { getItem } from '../../utils/Helper';
import navConfig from './NavConfig';
import BigLogo from '../../components/BigLogo';

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <BigLogo sx={{ width: 150, height: 60, mx: { xs: 'auto', md: 'inherit' } }} />
      </Box>

      <Box sx={{ mb: 3, mx: 1.5 }}>
        <Link underline="none" component={RouterLink} to="/app/profile">
          <AccountStyle>
            <Avatar
              src={`${process.env.REACT_APP_s3_cdn}/${process.env.REACT_APP_STAGE}${getItem(localStorage, 'dp')}`}
              alt="photoURL"
            />
            <Box sx={{ ml: 2, wordBreak: 'break-all' }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {getItem(localStorage, 'fn')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {getItem(localStorage, 'ue')}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      <NavSection navConfig={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
